import { usePortalSize } from "@src/Components/Common/usePortalSize"
import { Waiting } from "@src/Components/Waiting"
import { CompanyStatuses } from "@src/Constants/companyStatuses"
import C from "@src/Controller"
import { useLocale } from "@src/Hooks/useLocale"
import { tState } from "@src/Model/Model"
import { ViewTypes } from "@src/types"
import { isInvalidHost } from "@src/Utils"
import * as _ from "lodash"
import * as React from "react"
import { useSelector } from "react-redux"
import { Redirect, useHistory, useLocation } from "react-router-dom"

import OnBoardingForm from "./OnBoardingForm"

const OnBoardingContainer = () => {
  const { clientHeight, clientWidth, isDesktop } = usePortalSize()
  const { currentLocale } = useLocale()
  const webDomain = useSelector((state: tState) => state.brand.webDomain)

  const history = useHistory()
  const location = useLocation()
  const { authenticated, companyProfile, companyProfileState, signupData } =
    useSelector((state: tState) => state.portal)

  const brand = useSelector((state: tState) => state.brand)

  const onSubmit = (values: any, callback: () => void) => {
    C.Portal.saveOnBoardingForm(
      {
        ...values,
        adminProfile: {
          ...values.adminProfile,
          locale: currentLocale,
        },
      },
      callback,
    )
  }

  const goToIntro = () => history.push(ViewTypes.intro)

  React.useEffect(() => {
    if (!_.isEmpty(companyProfile) && companyProfileState === "SUCCESS") {
      goToIntro()
    }
  }, [companyProfile, companyProfileState])

  const inviteUser = (
    inviteUser: {
      email: string
      firstName: string
      lastName: string
      jobTitle: string
    },
    callback?: () => void,
  ) => {
    if (inviteUser.email) {
      C.Portal.inviteUser(
        inviteUser.email,
        inviteUser.firstName,
        inviteUser.lastName,
        inviteUser.jobTitle,
        (res: any) => {
          if (callback) {
            callback()
          }
          if (res.success) {
            C.toastNotification("Invited user successfully", "success")
          } else {
            C.toastNotification("Error in user invitation", "danger")
          }
        },
      )
    }
  }

  // TODO (@daniel.m) If this is used in more places, it should be split off from
  // here and from <PrivateRoute /> such that it can be used by itself
  if (!authenticated) {
    return (
      <Redirect
        to={{ pathname: ViewTypes.signin, state: { from: location } }}
      />
    )
  }

  if (isInvalidHost(webDomain)) {
    return (
      <Redirect
        to={{ pathname: ViewTypes.incorrectURL, state: { from: location } }}
      />
    )
  }

  return companyProfileState === CompanyStatuses.LOADING ? (
    <Waiting text="Loading..." height="100%" padding={100} />
  ) : (
    <OnBoardingForm
      height={clientHeight}
      width={clientWidth}
      isDesktop={isDesktop}
      onSubmit={onSubmit}
      inviteUser={inviteUser}
      goToIntro={goToIntro}
      signupData={signupData}
      brand={brand}
    />
  )
}

export default OnBoardingContainer
